// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledWrapper } from '../Styled';
import { Skeleton, Table } from '@/ui';
import { Pagination } from '@/components';

// Models
import { IPartnerProfile } from '@/models/partners.model';

// Modules
import PartnersFiltersContainer from '../../containers/PartnersFiltersContainer/PartnersFiltersContainer';

// Helpers
import { getPartnersTableColumns } from './columns';

type TPartnersList = {
  partnersList: IPartnerProfile[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  setPartnerForDelete: (partner: IPartnerProfile) => void;
  setForStatusChange: (partner: IPartnerProfile) => void;
  setHidePartner: (partner: IPartnerProfile) => void;
  onPageChange: (page: number) => void;
  authAsPartner: (id: string) => void;
  onResendInvitation: (id: string) => void;
};

const PartnersList = ({
  isLoading,
  partnersList,
  total,
  currentPage,
  onPageChange,
  authAsPartner,
  setPartnerForDelete,
  setForStatusChange,
  setHidePartner,
  onResendInvitation,
}: TPartnersList) => {
  const { t } = useTranslation(['usersList']);

  if (isLoading) return <Skeleton />;

  return (
    <StyledWrapper>
      <Table
        columns={getPartnersTableColumns({
          t,
          setPartnerForDelete,
          setHidePartner,
          setForStatusChange,
          authAsPartner,
          onResendInvitation,
        })}
        dataSource={partnersList}
        scroll={{ x: 'max-content' }}
        components={{
          header: {
            wrapper: PartnersFiltersContainer,
          },
        }}
      />
      <Pagination current={currentPage} total={total} onChange={onPageChange} />
    </StyledWrapper>
  );
};

export default PartnersList;
